import { ADD_TO_CART, REMOVE_FROM_CART, UPDATE_CART_ITEM, CLEAR_CART } from './types';
import { toast } from 'sonner';

// Action pour ajouter un produit au panier
export const addToCart = (product, quantity = 1) => (dispatch, getState) => {
  const { cart } = getState();
  const existingItem = cart.items.find(item => item.product._id === product._id);

  // Calcule la quantité totale actuelle du panier
  const totalQuantity = cart.items.reduce((sum, item) => sum + item.quantity, 0);

  // Vérifie la limite de 200 produits
  if (totalQuantity + quantity > 200) {
    toast.warning("🚫 Limite atteinte : vous ne pouvez pas avoir plus de 200 produits dans le panier.");
    return;
  }

  if (existingItem) {
    // Si le produit existe déjà, on met à jour la quantité
    dispatch(updateCartItem(product._id, existingItem.quantity + quantity));
    toast.success(`Quantité de ${product.name} mise à jour dans le panier`);
  } else {
    // Sinon, on ajoute un nouveau produit
    dispatch({
      type: ADD_TO_CART,
      payload: { product, quantity }
    });
    toast.success(`${product.name} ajouté au panier`);
  }

  // Sauvegarde du panier dans le localStorage
  localStorage.setItem("cart", JSON.stringify(getState().cart));
};


// Action pour retirer un produit du panier
export const removeFromCart = (productId) => (dispatch, getState) => {
  dispatch({
    type: REMOVE_FROM_CART,
    payload: productId
  });
  
  toast.info(`Produit retiré du panier`);
  
  // Mettre à jour le localStorage
  localStorage.setItem('cart', JSON.stringify(getState().cart));
};

// Action pour mettre à jour la quantité d'un produit dans le panier
export const updateCartItem = (productId, quantity) => (dispatch, getState) => {
  if (quantity <= 0) {
    return dispatch(removeFromCart(productId));
  }

  const { cart } = getState();

  // Calcule la quantité totale du panier si on appliquait la mise à jour
  const totalQuantityWithoutCurrent = cart.items
    .filter(item => item.product._id !== productId)
    .reduce((sum, item) => sum + item.quantity, 0);

  const newTotalQuantity = totalQuantityWithoutCurrent + quantity;

  // Vérifie la limite de 200 produits dans le panier
  if (newTotalQuantity > 200) {
    toast.warning("🚫 Vous ne pouvez pas dépasser 200 produits dans le panier.");
    return;
  }

  // Mise à jour de la quantité si la limite n’est pas dépassée
  dispatch({
    type: UPDATE_CART_ITEM,
    payload: {
      productId,
      quantity
    }
  });

  // Mise à jour du localStorage
  localStorage.setItem("cart", JSON.stringify(getState().cart));
};

// Action pour vider le panier
export const clearCart = () => (dispatch) => {
  dispatch({ type: CLEAR_CART });
  localStorage.removeItem('cart');
  toast.info('Panier vidé');
};

// Action pour initialiser le panier depuis le localStorage
export const initCart = () => (dispatch) => {
  const savedCart = localStorage.getItem('cart');
  
  if (savedCart) {
    const parsedCart = JSON.parse(savedCart);
    
    dispatch({
      type: 'INIT_CART',
      payload: parsedCart,
    });
  }
};